// extracted by mini-css-extract-plugin
export default {"secondaryItemLabel":"ContactRessourcePicker_secondaryItemLabel__A9tN5"};